export default {
  name: 'workflow-definition',
  translationKey: 'workflow-module',
  routePrefix: 'workflow-definition',
  routeNamePrefix: 'admin.workflow-definition',
  directRoutesAvailable: false,
}
